import { useQuery } from '@tanstack/react-query';
import {
  fetchDashboardSummary,
  fetchLatestTransaction,
  fetchStockHighlights,
} from '../apis/dashboard';

/** Beranda total cards. */
export const useDashboardSummary = () =>
  useQuery({ queryKey: ['dashboard', 'summary'], queryFn: fetchDashboardSummary });

/** Transaksi Terakhir: the newest order of any status, or null. */
export const useLatestTransaction = () =>
  useQuery({ queryKey: ['dashboard', 'latest-transaction'], queryFn: fetchLatestTransaction });

/** Highlight Stok: best seller, out of stock, low stock. */
export const useStockHighlights = (limit?: number, threshold?: number) =>
  useQuery({
    queryKey: ['dashboard', 'stock-highlights', limit, threshold],
    queryFn: () => fetchStockHighlights(limit, threshold),
  });
